<template>
  <div
    :style="{ width: width, maxWidth: maxWidth, margin: '0 auto', backgroundColor: wrapperBackground }"
    class="keyboard-wrapper"
  >
    <slot
      :setKeyboardInput="setKeyboardInput"
      name="input"
    />
    <div
      :class="[ keyboardClass, 'pt-2' ]"
      :style="{ backgroundColor: keyboardBackground }"
      class="simple-keyboard"
    />
  </div>
</template>

<script>
import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'

export default {
  name: 'NumericKeyboard',

  props: {
    layout: {
      type: Array,
      required: false,
      default: () => [`1 2 3`, `4 5 6`, `7 8 9`, `. 0 {clear}`]
    },
    maxWidth: {
      type: String,
      required: false,
      default: '320px'
    },
    keyboardClass: {
      type: String,
      default: 'keyboard'
    },
    keyboardBackground: {
      type: String,
      required: false,
      default: '#e0e0e0'
    },
    wrapperBackground: {
      type: String,
      required: false,
      default: '#f9f9f9'
    },
    clearInput: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: 'auto'
    }
  },

  data: () => ({
    keyboard: null
  }),

  computed: {
    hasInputSlot () {
      return !!this.$slots['input']
    }
  },

  watch: {
    clearInput: {
      handler (val) {
        if (val) {
          this.clear()
        }
      }
    }
  },

  mounted () {
    this.keyboard = new Keyboard(`.${this.keyboardClass}`, {
      onChange: input => this.onChange(input),
      onKeyPress: button => this.onKeyPress(button),
      layout: {
        default: this.layout
      },
      mergeDisplay: true,
      theme: 'simple-keyboard hg-theme-default hg-layout-numeric numeric-theme',
      display: {
        '{bksp}': '<i class="far fa-backspace"></i>',
        '{enter}': '<i class="far fa-check"></i>',
        '{clear}': 'C'
      }
    })
  },

  methods: {
    setKeyboardInput (input) {
      this.keyboard.setInput(input)
    },
    clear () {
      this.keyboard.clearInput()
    },
    onChange (input) {
      this.$emit('input', input)
    },
    onKeyPress (button) {
      this.$emit('click', button)
      switch (button) {
        case '{enter}':
          if (this.keyboard) this.clear()
          this.$emit('submit')
          break
        case '{clear}':
          if (this.keyboard) this.clear()
          this.$emit('clear')
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .simple-keyboard {
    border-radius: 0 !important;
    padding-top: 12px !important;
    /deep/ .hg-button {
      background-color: #f9f9f9;
      font-size: 2em;
      color: rgb(138, 135, 135);
      max-width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NumericKeyboard.vue